import { FC } from 'react'

import { cn } from 'src/lib/cn'
import { Product } from 'src/utils/product'
import Badge, { BADGE_TYPE } from '../../atoms/Badge'
import ProductIcon from '../../atoms/ProductIcon'

interface SidebarMenuProductIconProps {
  code: Product | 'self_service' | 'data_availability'
  isActive?: boolean
  notificationCount?: number
}

const SidebarMenuProductIcon: FC<SidebarMenuProductIconProps> = ({
  code,
  isActive,
  notificationCount,
}) => {
  return (
    <div
      className={cn(
        'bg-selago text-dove-gray relative flex size-6 items-center justify-center rounded-sm',
        isActive && 'bg-bay-of-many text-selago',
      )}
    >
      <ProductIcon
        width={undefined}
        height={undefined}
        preserveAspectRatio="xMidYMid"
        productCode={code as any}
        className="size-4"
      />
      {Boolean(notificationCount) && (
        <Badge
          type={BADGE_TYPE.notificationMenu}
          label={notificationCount}
          className="bg-gallery text-dove-gray absolute -right-[0.43px] -bottom-[1.32px] h-[10.82px] rounded-[1px] px-0.5 text-[8px] font-bold"
        />
      )}
    </div>
  )
}

export default SidebarMenuProductIcon
